<div class="score-table-mobile d-flex flex-column align-items-center">
    <div class="w-100">
        <div id="div-entries" class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3 g-3">
        </div>
    </div>
    <button class="btn btn-primary m-2" id="btn-add-row">Add entry</button>
</div>